import type { 
  ResponseLike, 
  ErrorContext, 
  FormattedError, 
  HandlerOptions, 
  X402Handler
} from './types.js';
import { parseX402Response } from './core/parser.js';
import { mapToErrorContext } from './core/mapper.js';

export { X402ErrorCodes } from './core/error-codes.js';


export type { 
  ResponseLike, 
  ErrorContext, 
  FormattedError, 
  Severity, 
  RecoveryIntent,
  TelemetryHook,
  X402Handler 
} from './types.js';

export function parseX402Error(res: ResponseLike): Promise<ErrorContext | null> {
  return createX402Handler().parse(res);
}

export function formatError(ctx: ErrorContext): FormattedError {
  return createX402Handler().format(ctx);
}

export function createX402Handler(options?: HandlerOptions): X402Handler {
  const telemetry = options?.telemetry;
  
  const emitTelemetry = (type: 'error_parsed' | 'recovery_suggested', ctx: ErrorContext) => {
    if (telemetry) {
      telemetry({
        type,
        code: ctx.code,
        severity: ctx.severity,
        timestamp: Date.now(),
        metadata: ctx.raw
      });
    }
  };
  
  return {
    async parse(res: ResponseLike): Promise<ErrorContext | null> {
      const parsed = await parseX402Response(res);
      if (!parsed) {
        return null;
      }
      
      const context = mapToErrorContext(parsed);
      emitTelemetry('error_parsed', context);
      return context;
    },
    
    format(ctx: ErrorContext): FormattedError {
      const shouldRetry = ctx.severity === 'retryable';
      const shouldStop = ctx.severity === 'fatal' || ctx.severity === 'user';
      
      emitTelemetry('recovery_suggested', ctx);
      
      return {
        code: ctx.code,
        message: ctx.message,
        severity: ctx.severity,
        recoveryIntent: ctx.recoveryIntent,
        shouldRetry,
        shouldStop,
        metadata: ctx.raw
      };
    }
  };
}